import * as React from 'react';
import './Stats.css';
import Pie from '../assets/Pie';
import FifteenPercent from '../assets/15';
import OneToFive from '../assets/1to5';
import EightyFive from '../assets/85';
import FifteenJP from '../assets/15JP.svg';
import EightyFiveJP from '../assets/85JP.svg';
import OneToFiveJP from '../assets/1-5JP.svg';
import { ReactSVG } from 'react-svg';
import { Trans } from 'react-i18next';
import { i18n, TFunction } from 'i18next';

interface props {
    t: TFunction;
    i18n: i18n;
}

const Stats = ({t, i18n}:props) => {
    return (
        <div className='slide' id='stats'>
            <h2 className='slide-title'>{t('statsTitle')}</h2>
            <h4 className='stats-subtitle'>{t('statsSubtitle')}</h4>
            <p className='stats-p'>
                <Trans i18nKey='statsP'>
                    Overall only <strong>15-20%</strong> of manga is available 
                    to english<br></br>speaking audiences.
                </Trans>
            </p>
            <div className='graph'>
                <Pie className='pie' />
                {i18n.resolvedLanguage === 'en' ? 
                  <OneToFive className='one-to-five' /> : 
                  <ReactSVG src={OneToFiveJP} className='one-to-five' />}
                {i18n.resolvedLanguage === 'en' ? 
                  <FifteenPercent className='fifteen'/> :
                  <ReactSVG src={FifteenJP} className='fifteen' />}
                {i18n.resolvedLanguage === 'en' ? 
                  <EightyFive className='eightyfive' /> :
                  <ReactSVG src={EightyFiveJP} className='eightyfive' />
                }
            </div>
        </div>
    )
}

export default Stats;